export default __webpack_public_path__ + "static/logo-blk-79111d9dac9f1374b9d3715e257eece9.png";